import { render } from "./media-viewer.vue?vue&type=template&id=7b220955&scoped=true"
import script from "./media-viewer.vue?vue&type=script&lang=js"
export * from "./media-viewer.vue?vue&type=script&lang=js"

import "./media-viewer.vue?vue&type=style&index=0&id=7b220955&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b220955"]])

export default __exports__